<template>
  <span
    v-tooltip.top="fullLabel"
    :class="badgeClasses"
  >
    {{ displayLabel }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import {
  CANDIDATE_STATUS_SEMANTIC_TONE,
  getStatusLabel,
  getStatusShortLabel
} from '@/features/hr-workspace/data/candidateStatusConfig';

const props = defineProps({
  status: { type: String, required: true },
  label: { type: String, default: '' },
  subtle: { type: Boolean, default: false }
});

const fullLabel = computed(() => {
  if (props.label) return props.label;
  return getStatusLabel(props.status);
});

const displayLabel = computed(() => {
  if (props.label) return props.label;
  return getStatusShortLabel(props.status);
});

const tone = computed(() => CANDIDATE_STATUS_SEMANTIC_TONE[props.status] || 'neutral');

const showDot = computed(() => tone.value === 'info' || tone.value === 'warning');

const badgeClasses = computed(() => [
  'candidate-status-badge',
  `candidate-status-badge--${tone.value}`,
  {
    'candidate-status-badge--with-dot': showDot.value,
    'candidate-status-badge--subtle': props.subtle
  }
]);
</script>

<style scoped>
.candidate-status-badge--subtle {
  font-size: 0.6875rem;
  font-weight: 600;
  opacity: 0.92;
}
</style>
